// src/store/pvinFilterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedFilter: {}, // store dynamic key-value payload
};

const PvinFilterSlice = createSlice({
  name: "pvinFilter",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      // action.payload is now an object like { Contact_Number: ["9876543210"] }
      state.selectedFilter = action.payload;
    },
    clearFilter: (state) => {
      state.selectedFilter = {};
    },
  },
});

export const { setFilter, clearFilter } = PvinFilterSlice.actions;
export default PvinFilterSlice.reducer;
